import 'Utilities/polyfills'
import loader from 'ct'

document.addEventListener('DOMContentLoaded', loader.attachListeners)
